import { render, staticRenderFns } from "./TradingOrders.vue?vue&type=template&id=dc657862&scoped=true&"
import script from "./TradingOrders.vue?vue&type=script&lang=js&"
export * from "./TradingOrders.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrders.vue?vue&type=style&index=0&id=dc657862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc657862",
  null
  
)

export default component.exports